import { render, staticRenderFns } from "./importTemplate.vue?vue&type=template&id=4a987c1c&scoped=true&"
import script from "./importTemplate.vue?vue&type=script&lang=js&"
export * from "./importTemplate.vue?vue&type=script&lang=js&"
import style0 from "./importTemplate.vue?vue&type=style&index=0&id=4a987c1c&prod&lang=scss&"
import style1 from "./importTemplate.vue?vue&type=style&index=1&id=4a987c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a987c1c",
  null
  
)

export default component.exports